<div class="main">
  <div class="container-fluid">
    <div id="fileForm" class="card">
      <div class="card-header-customer">
        <h5>{{ dynamicForm?.tittle }}</h5>
      </div>
      <div class="card-body mt-4">
        <div class="row">
          <div class="col-12 d-flex mb-4">
            <table class="table">
              <thead>
                <tr></tr>
              </thead>
              <tbody>                
                <ng-container *ngFor="let sectionDisp of dynamicForm?.sectionsDisposition">                  
                  <ng-container *ngFor="let questionDisp of sectionDisp.section.questionsDisposition">                    
                    <!-- <tr *ngIf="(questionDisp.question.visible && !questionDisp.question.rfv_RequiredFieldValidatorControl) || showHiddenFields"> -->
                      <tr *ngIf="checkQuestionVisibility(questionDisp.question)">
                      <td>{{ questionDisp.question.lbl_LabelText }}</td>                      
                      <td class="text-center">
                        <ng-container [ngSwitch]="getControlType(questionDisp).type">
                          
                          <!-- Input Field -->
                          <ng-container *ngSwitchCase="'input'">
                            <input 
                              [type]="getControlType(questionDisp).inputType" 
                              class="form-control mb-2"
                              [(ngModel)]="responses[questionDisp.question.keyName]"                               
                              [value]="responses[questionDisp.question['keyName']]"
                              [attr.placeholder]="questionDisp.question.defaultValue" 
                            />
                          </ng-container>

                          <!-- DropdownList and Dynamic Dropdown-->
                          <ng-container *ngSwitchCase="'dropdown'">
                            <select class="form-select mb-2"                                     
                            [ngModel]="responses[questionDisp.question.keyName]"
                            (ngModelChange)="OnSelectDDL(questionDisp.question.keyName, $event)"
                            [attr.placeholder]="questionDisp.question.defaultValue" >                            
                              <option *ngFor="let result of getControlTypeOptions(questionDisp)?.[0]?.content" [value]="result.value" >
                                {{ result.text }}
                              </option>
                            </select>
                          </ng-container>                         
                          
                        </ng-container>
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>
              </tbody>
            </table>            
          </div>
        </div>
      </div>
    </div>
    <button class="btn btn-primary" (click)="onSaveResponses()">
      Guardar Respuestas
    </button>
  </div>
</div>
